import PropTypes from "prop-types";
import KeyboardDoubleArrowUpOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowUpOutlined";
import KeyboardDoubleArrowDownOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowDownOutlined";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { OverviewCardContainer } from "./card-container";

export const InfoCard = (props) => {
  const { title, value, sx, color, difference, differenceText, positive, renderIcon } = props;

  return (
    <OverviewCardContainer sx={sx} color={color}>
      <Stack alignItems="flex-start" direction="row" justifyContent="space-between" spacing={3}>
        <Stack spacing={1}>
          <Typography color="#fff" variant="overline">
            {title}
          </Typography>
          <Typography variant="h4" color="#fff">
            {value}
          </Typography>
        </Stack>
        <Avatar
          sx={{
            height: 56,
            width: 56,
            background: "transparent",
            border: "2px solid",
          }}
        >
          <SvgIcon>{renderIcon()}</SvgIcon>
        </Avatar>
      </Stack>
      {difference && (
        <Stack alignItems="center" direction="row" spacing={2} sx={{ mt: 2 }}>
          <Stack alignItems="center" direction="row" spacing={0.5}>
            <SvgIcon color={positive ? "success" : "error"} fontSize="small">
              {positive ? <KeyboardDoubleArrowUpOutlinedIcon /> : <KeyboardDoubleArrowDownOutlinedIcon />}
            </SvgIcon>
            <Typography color={positive ? "success.main" : "error.main"} variant="body2">
              {difference}
            </Typography>
          </Stack>
          <Typography color="text.secondary" variant="caption">
            {differenceText}
          </Typography>
        </Stack>
      )}
    </OverviewCardContainer>
  );
};

InfoCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  sx: PropTypes.object,
  positive: PropTypes.bool,
  difference: PropTypes.string,
  differenceText: PropTypes.string,
  renderIcon: PropTypes.func,
};
